const STATUSES_PT = {
  added: "Adicionado",
  archived: "Arquivado",
  canceled: "Cancelado",
  complete: "Completo",
  confirmed: "A chegar",
  ended: "Terminado",
  expired: "Expirado",
  expires_soon: "Expira em breve",
  incomplete: "Incompleto",
  paid: "Pago",
  paymentToCome: "Pagamento pendente",
  pending: "Pendente",
  proposed: "Proposto",
  refused: "Recusado",
  scheduled: "A processar",
  sent: "A processar",
  started: "Iniciado",
  to_add: "A adicionar",
  to_renew: "A renovar",
  toAdd: "A adicionar",
  toCome: "A chegar",
  toCorrect: "A corrigir",
  toJustify: "A justificar",
  toPay: "A pagar",
  up_to_date: "Atualizado",
  validated: "Validado",
  validationInProgress: "Validação em curso",
  waiting_for_confirmation: "A chegar",
  waiting_for_validation: "Em curso",
} as const;

export default STATUSES_PT;
